export default "__VITE_ASSET__CmYWwWQB__"